import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';
import { BaseControl, TextControl, ToggleControl } from '@wordpress/components';

import PanelBody from '../../components/PanelBody';
import ColorPicker from '../../components/ColorPicker';
import Slider from '../../components/Slider';

export default function Inspector({ attributes, setAttributes }) {
  const {
    value,
    max,
    showValue,
    valueSuffix,
    height,
    rounded,
    barColor,
    trackColor,
    animate,
    duration,
  } = attributes;

  return (
    <InspectorControls>
      <PanelBody title={__('Value', 'brandy-blocks')} initialOpen>
        <Slider
          label={__('Value', 'brandy-blocks')}
          value={value}
          onChange={(next) => setAttributes({ value: next })}
          min={0}
          max={max}
        />

        <TextControl
          label={__('Full scale', 'brandy-blocks')}
          help={__('The value that counts as 100%.', 'brandy-blocks')}
          type="number"
          value={max}
          onChange={(next) => setAttributes({ max: Math.max(1, parseFloat(next) || 1) })}
          __nextHasNoMarginBottom
        />

        <ToggleControl
          label={__('Show the value', 'brandy-blocks')}
          checked={showValue}
          onChange={(next) => setAttributes({ showValue: next })}
          __nextHasNoMarginBottom
        />

        {showValue && (
          <TextControl
            label={__('Value suffix', 'brandy-blocks')}
            value={valueSuffix}
            onChange={(next) => setAttributes({ valueSuffix: next })}
            __nextHasNoMarginBottom
          />
        )}
      </PanelBody>

      <PanelBody title={__('Bar', 'brandy-blocks')} initialOpen>
        <Slider
          label={__('Thickness (px)', 'brandy-blocks')}
          value={height}
          onChange={(next) => setAttributes({ height: next })}
          min={2}
          max={48}
        />

        <ToggleControl
          label={__('Rounded ends', 'brandy-blocks')}
          checked={rounded}
          onChange={(next) => setAttributes({ rounded: next })}
          __nextHasNoMarginBottom
        />

        <BaseControl.VisualLabel>
          {__('Bar color', 'brandy-blocks')}
        </BaseControl.VisualLabel>
        <ColorPicker
          color={barColor}
          onChange={(next) => setAttributes({ barColor: next })}
        />

        <BaseControl.VisualLabel>
          {__('Track color', 'brandy-blocks')}
        </BaseControl.VisualLabel>
        <ColorPicker
          color={trackColor}
          onChange={(next) => setAttributes({ trackColor: next })}
        />
      </PanelBody>

      <PanelBody title={__('Animation', 'brandy-blocks')} initialOpen={false}>
        <ToggleControl
          label={__('Fill when scrolled into view', 'brandy-blocks')}
          help={__(
            'Readers who ask for reduced motion always see the finished bar.',
            'brandy-blocks'
          )}
          checked={animate}
          onChange={(next) => setAttributes({ animate: next })}
          __nextHasNoMarginBottom
        />

        {animate && (
          <Slider
            label={__('Duration (ms)', 'brandy-blocks')}
            value={duration}
            onChange={(next) => setAttributes({ duration: next })}
            min={200}
            max={4000}
            step={100}
          />
        )}
      </PanelBody>
    </InspectorControls>
  );
}
